import { AddressModel } from "../address.model";

export class VenueFinance {
	venueKey: number;
	contracts: Contract[];
	invoices: Invoice[];
	subscriptions: Subscription[];
	paymentProfiles: PaymentProfile[];

	public constructor(init?: Partial<VenueFinance>) {
		Object.assign(this, init);
	}
}

export class Contract {
	key: string;
	contractId: string;
	startDate: Date;
	endDate: Date;
	durationMonths: number;
	monthsRemaining: number;
	active: boolean;
	status: string;
	autoRenew: boolean;
	lines: ContractLine[];

	public constructor(init?: Partial<Contract>) {
		Object.assign(this, init);
	}
}

export class ContractLine {
	contractKey: string;
	lineDescription: string;
	price: number;
	quantity: number;
	extension: number;
	createdDate: Date;

	public constructor(init?: Partial<ContractLine>) {
		Object.assign(this, init);
	}
}

export class Invoice {
	key: string;
	createdDate: Date;
	dueDate: Date;
	termsLabel?: string;
	externalId: string;
	invoiceNumber: string;
	referenceString: string;
	total: number;
	balanceDue: number;
	paymentsApplied: number;
	paymentUrl: string;
	lines: InvoiceLine[];
	payments: InvoicePayment[];

	public constructor(init?: Partial<Invoice>) {
		Object.assign(this, init);
	}
}

export class InvoiceLine {
	invoiceKey: string;
	key: string;
	lineDescription: string;
	price: number;
	quantity: number;
	extension: number;
	discountValue: number;

	public constructor(init?: Partial<InvoiceLine>) {
		Object.assign(this, init);
	}
}

export class InvoicePayment {
	invoiceKey: string;
	key: string;
	method: string;
	account: string;
	amount: number;
	date: Date;

	public constructor(init?: Partial<InvoicePayment>) {
		Object.assign(this, init);
	}
}

export class Subscription {
	key: string;
	name: string;
	startDate: Date;
	endDate: Date;
	billingFrequency: string;
	nextBillingDate: Date;
	active: boolean;
	created: Date;
	quantityBilled: number;
	amount: number;
	contract: Contract;
	autoBillPay: boolean;
	autoBillPayPaymentMedium: string;
	lines: SubscriptionLine[];

	public constructor(init?: Partial<Subscription>) {
		Object.assign(this, init);
	}
}

export class SubscriptionLine {
	invoiceKey: string;
	key: string;
	lineDescription: string;
	price: number;
	quantity: number;
	extension: number;
	discountValue: number;
	nextBillingDate: Date;
	billingFrequency: string;
	autoBillPay: boolean;
	autoBillPayPaymentMedium: string;

	public constructor(init?: Partial<SubscriptionLine>) {
		Object.assign(this, init);
	}
}

export class CustomerMatchModel {
	name: string;
	value: string;
	venueKey: number;
	address: AddressModel;

	public constructor(init?: Partial<CustomerMatchModel>) {
		Object.assign(this, init);
	}
}

export class PaymentProfile {
	bankAccountNumber: string;
	bankName: string;
	bankRoutingNumber: string;
	billingCity: string;
	billingContactEmail: string;
	billingContactFirstName: string;
	billingContactLastName: string;
	billingPostalCode: string;
	billingState: string;
	billingStreet: string;
	createdDate: Date;
	creditCardDaysToExpiry: number;
	creditCardExpirationDate: string;
	creditCardNumber: string;
	creditCardType: string;
	defaultProfile: boolean;
	lastModifiedDate: Date;
	profileName: string;
	profileNote: string;
	profilePaymentType: string;
	recordId: string;

	public constructor(init?: Partial<PaymentProfile>) {
		Object.assign(this, init);
	}
}
